import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';

type BannersState = {
  page: number;
  perPage: number;
  filters: Record<string, any>;
}

const initialState: BannersState = {
  page: 1,
  perPage: 24,
  filters: { auction_type: [], status: '' }
};

const bannersSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {
      setPage: (state, action: PayloadAction<number>) => {
        state.page = action.payload;
      },
      setFilters(state, action: PayloadAction<Record<string, any>>) {
        state.filters = action.payload
      },
      resetFilters(state) {
        state.page = 1;
        state.perPage = 24;
        state.filters = { auction_type: [], status: '' }
      }
    }
});

export const useBannerFilters = () => {
  const filters = useSelector<{ banners: BannersState }, BannersState>((state) => state.banners)
  return filters
}

export const { setPage, setFilters, resetFilters } = bannersSlice.actions
export default bannersSlice;
